'use strict';

import Layer from './Layer';
import {scroll,toObject} from '../lang';

const {Server} = window.server;


export default class Calculator {
  /**
   * @param {Object} descriptor
   * @param {Object} descriptor.state
   * @param {Object} descriptor.dictionaries
   * @param {Object} descriptor.relations
   * @param {Array<Object>} descriptor.rates
   * @param {Object} descriptor.server
   * @param {Object} descriptor.scrolling
   */
  constructor(descriptor) {
    let {state,dictionaries,rates,relations,server,scrolling} = descriptor;
    this.dictionaries = dictionaries;
    this.relations = relations;
    this.scrolling = scrolling;
    this.state = state;
    this.server = new Server(server);
    this.hashes = this.getHashes(dictionaries);
    this.hashes.rates = this.getHashOfRates(rates);
    this.scroll = scroll;
    this.layers = {
      thanks: new Layer(),
      error: new Layer()
    };
  }
  /**
   * 
   */
  reset() {
    this.layers.thanks.hide();
  }
  /**
   * @param {Object} state
   * @returns {Boolean}
   */
  isValid(state) {
    let {customerName,customerPhone} = state;
    customerPhone = String(customerPhone);
    return Boolean(customerName) && customerPhone.length === 10;
  }
  /**
   * @returns {Number}
   */
  getFirstPaymentPrice() {
    return this.state.flatCost * this.state.firstPayment;
  }
  /**
   * @param {Object} dictionaries
   * @returns {Object}
   */
  getHashes(dictionaries) {
    let hashes = {};
    for(let key in dictionaries) {
      if (dictionaries.hasOwnProperty(key)) {
        hashes[key] = toObject(dictionaries[key]);
      }
    }
    return hashes;
  }
  /**
   * @param {Array<Object>} rates
   * @returns {Object}
   */
  getHashOfRates(rates) {
    return toObject(rates, getRateKey);
  }
  /**
   * @param {Number} bankId
   * @returns {String}
   */
  keyOfRate(bankId) {
    let {houseId,ageId} = this.state;
    return getRateKey({bankId,houseId,ageId});
  }
  /**
   * @param {Number} bankId
   * @returns {Number}
   */
  calcMonthPayment(bankId) {
    let rate = this.hashes.rates[this.keyOfRate(bankId)];
    if (!rate) {
      // throw new Error('There is no "rate". Cannot calculate a mouth payment.');
      return NaN;
    }
    // formula
    let S = this.state.flatCost * (1 - this.state.firstPayment);
    let P = rate.rate / 12;
    let N = this.hashes.ages[this.state.ageId].value * 12;
    return S * (P + P / (Math.pow(1 + P, N) - 1));
  }
  /**
   * @param {Object} state
   * @returns {Promise.<T>|*}
   */
  requestMortgage(state) {
    this.layers.thanks.hide();
    this.layers.error.hide();
    return this.server.requestMortgage.send(state)
      .then(this.onRequestMortgageSuccess.bind(this),
        this.onRequestMortgageError.bind(this));
  }
  /**
   * @param {Object} response
   * @returns {Object}
   */
  onRequestMortgageSuccess(response) {
    let {flag} = response;
    if (flag) {
      this.layers.thanks.show();
      return response;
    } else {
      return this.onRequestMortgageError(response);
    }
  }
  /**
   * @param {*} response
   * @returns {*}
   */
  onRequestMortgageError(response) {
    this.layers.error.show();
    return response;
  }
}


/**
 * @param {Object} o
 * @returns {string}
 */
function getRateKey(o) {
  return `${o.bankId}:${o.houseId}:${o.ageId}`;
}


// WEBPACK FOOTER //
// ./src/js/classes/Calculator.js